<template>
  <div class="entity-association">
    <el-form :model="queryParams" :rules="rules" ref="queryParamsForm">
      <p class="info-title">关联行为信息</p>
      <div class="business-info-block">
        <div class="business-info-block">
          <div
            class="each-data"
            v-for="(item, index) in queryParams.behaviorList"
            :key="index"
          >
            <el-form-item label="关联行为编号：" :rules="[{ required: true, message: '行为编号不能为空', trigger: 'blur' }]" label-width="190px">
              <el-input
                v-model="item.behaviorLabelId"
                style="width: 470px"
              />

              <span style="color: #4e93fb" @click="addScenario()">
                <i class="el-icon-circle-plus-outline"></i>
              </span>

              <span
                v-if="index > 0"
                style="color: #ff7575"
                @click="delScenario(index)"
              >
                <i class="el-icon-remove-outline"></i>
              </span>
            </el-form-item>

            <el-form-item label="关联行为名称：" :rules="[{ required: true, message: '行为名称不能为空', trigger: 'blur' }]" label-width="190px">
              <el-autocomplete
                class="inline-input"
                v-model="item.behaviorLabelName"
                :fetch-suggestions="selectBehaviorLabelByName"
                :trigger-on-focus="false"
                style="width: 470px"
                @select="val => behaviorLabelByNameHandel(val, index)"
              ></el-autocomplete>
            </el-form-item>
          </div>
        </div>
      </div>

      <p class="info-title">应用场景信息</p>

      <div class="business-info-block">
        <div
          class="each-data"
          v-for="(item, index) in queryParams.sceneList"
          :key="index"
        >
          <el-form-item label="应用场景编号：" :rules="[{ required: true, message: '应用场景编号不能为空', trigger: 'blur' }]" label-width="190px">
            <el-input v-model="item.sceneId" style="width: 470px" />

            <span style="color: #4e93fb" @click="addPlanrio()">
              <i class="el-icon-circle-plus-outline"></i>
            </span>

            <span
              v-if="index > 0"
              style="color: #ff7575"
              @click="delPlanio(index)"
            >
              <i class="el-icon-remove-outline"></i>
            </span>
          </el-form-item>

          <el-form-item label="应用场景名称：" :rules="[{ required: true, message: '应用场景名称不能为空', trigger: 'blur' }]" label-width="190px">
            <el-autocomplete
              class="inline-input"
              v-model="item.labelName"
              :fetch-suggestions="getScenarioByLabelName"
              :trigger-on-focus="false"
              style="width: 470px"
              @select="val => scenarioByLabelNameHandel(val, index)"
            ></el-autocomplete>
          </el-form-item>

        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
// 场景信息数据模版
const tempScenarioData = {
  behaviorLabelId: null,
  behaviorLabelName: ''
};

const tempPlanData = {
  sceneId: null,
  sceneName: ''
};

// components
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";
// api
import { getAssociationInfo, updateAssociationInfo, selectBehaviorLabelByName } from "@/api/productClassify.js";
import { getScenarioByLabelName, getScenarioById } from "@/api/Sceneknowledge.js"

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SelectTreeRadio
  },
  data() {
    //这里存放数据
    return {
      queryParams: {
        categoryCode: this.$route.query.productCode, // 产品类别编号
        // 行为信息
        behaviorList: [
          {
            productCategoryId: this.$route.query.productCode,
            behaviorLabelId: null,
            behaviorLabelName: ''
          }
        ],
        // 场景信息
        sceneList: [
          {
            productCategoryId: this.$route.query.productCode,
            sceneId: null,
            labelName: ''
          }
        ]
      },
      rules: {

      },
      scenarioList: [],
      behaviorList: []
    };
  },
  methods: {
    scenarioByLabelNameHandel(item, index) {
      this.queryParams.sceneList[index].sceneId = item.id
    },
    async getScenarioByLabelName(labelName, cb) {
      const res = await getScenarioByLabelName({queryConditions: labelName})
      if(res.code === 200) {
        this.scenarioList = res.data
        this.scenarioList.forEach(item => {
          item.value = item.sceneName
        })
        cb(this.scenarioList)
      }
    },
    async selectBehaviorLabelByName(labelName, cb) {
      const res = await selectBehaviorLabelByName({queryConditions: labelName})
      if(res.code === 200) {
        this.behaviorList = res.data
        this.behaviorList.forEach(item => {
          item.value = item.labelName
        })
        cb(this.behaviorList)
      }
    },
    behaviorLabelByNameHandel(item, index) {
      this.queryParams.behaviorList[index].behaviorLabelId = item.id
    },
    getInfo() {
      getAssociationInfo({ id: this.$route.query.productCode }).then(
        res => {
          if (res.code === 200) {
            if(Array.isArray(res.data.behaviorList) && res.data.behaviorList.length > 0) {
              this.queryParams.behaviorList = res.data.behaviorList
            }
            if(Array.isArray(res.data.sceneList) && res.data.sceneList.length > 0) {
              this.queryParams.sceneList = res.data.sceneList
            }
          }
        }
      );
    },
    submit() {
      updateAssociationInfo(this.queryParams).then(res => {
        if (res.code === 200) {
          this.$message.success("编辑成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    addScenario() {
      this.queryParams.behaviorList.push(
        JSON.parse(JSON.stringify(tempScenarioData))
      );
    },
    delScenario(index) {
      this.queryParams.behaviorList.splice(index, 1);
    },
    addPlanrio() {
      this.queryParams.sceneList.push(JSON.parse(JSON.stringify(tempPlanData)));
    },
    delPlanio(index) {
      this.queryParams.sceneList.splice(index, 1);
    }
  }
};
</script>

<style scoped lang="less">
.entity-association {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .business-info-block {
    border-bottom: 20px solid #d8efff;

    &:last-child {
      border-bottom: 0;
    }

    .table-box {
      margin-top: 10px;
      padding-left: 190px;
      padding-bottom: 10px;

      .table-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        font-size: 16px;
        color: #333333;

        &::before {
          content: "";
          display: block;
          margin-right: 4px;
          width: 7px;
          height: 7px;
          background-color: #1e9fff;
          border-radius: 50%;
        }
      }
    }
  }

  /deep/ .el-icon-circle-plus-outline {
    font-size: 31px;
    vertical-align: middle;
    color: #698eef;
    cursor: pointer;
    padding-left: 10px;
  }

  /deep/ .el-icon-remove-outline {
    font-size: 31px;
    vertical-align: middle;
    color: red;
    cursor: pointer;
    padding-left: 10px;
  }
}
</style>
